export class SVGImage {
	private static SVG_NAMESPACE: string = 'http://www.w3.org/2000/svg';
	private static SVG_URI_PREFIX: string = 'data:image/svg+xml;charset=utf-8,';

	// Current SVG and elements to be added
	private SVGData: string;
	private SVGElements: string[] = [];

	// Lazy approach to SVG construction
	private SVGDataNew: string;
	private hasNewElements = true;

	// Dimension of SVG image
	private width: number;
	private height: number;
	private attributes: string;
	private namespace: string;

	constructor(width: number, height: number, attributes: string = '', namespace: string = SVGImage.SVG_NAMESPACE) {
		// Get data
		this.width = width;
		this.height = height;
		this.attributes = attributes;
		this.namespace = namespace;

		// Create basic SVG
		this.SVGData = this.createEmptySVG();
	}

	public setSVGFromString(str: string) {
		// TODO check dimensions
		this.SVGData = str;
	}

	public getSVGUpdateString() {
		this.constructSVG();
		return this.SVGDataNew;
	}

	public getSVGUpdateURI() {
		return SVGImage.SVG_URI_PREFIX + this.getSVGUpdateString();
	}

	public getSVGString() {
		this.constructSVG();
		return this.SVGData;
	}

	public getSVGURI() {
		return SVGImage.SVG_URI_PREFIX + this.getSVGString();
	}

	public hasChanged(): boolean {
		return this.hasNewElements;
	}

	public forceUpdate(): void {
		this.hasNewElements = true;
	}

	public setBackgroundColor (color: string): void {
		if (this.SVGData.includes('background')) {
			this.SVGData = this.SVGData.replace(/id="background" fill=".*?"/, 'id="background" fill="' + color + '"');
		} else {
			this.addRect(0, 0 , this.width, this.height, 'id="background" fill="' + color + '"');
		}

		this.hasNewElements = true;
	}

	// Weird code but faster: http://jsben.ch/YXvpj
	public addLine (x1: number, y1: number, x2: number, y2: number, attributes: string = ''): void {
		let line: string = '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" ' + attributes + '/>';
		this.addElement(line);
	}

	public addRect (x: number, y:number, width: number, height: number, attributes: string = ''): void {
		let rect: string = '<rect x="' + x + '" y="' + y + '" width="' + width + '" height="' + height + '" ' + attributes + '/>';
		this.addElement(rect);
	}

	public addCircle (cx: number, cy: number, r: number, attributes: string = ''): void {
		let circle: string = '<circle cx="' + cx + '"cy="' + cy + '"r="' + r + '"' + attributes + '/>';
		this.addElement(circle);
	}

	private createEmptySVG() {
		let SVGData = '<svg xmlns="' + this.namespace + '"';
		SVGData += ' width="' + this.width + '"';
		SVGData += ' height="' + this.height + '"';
		SVGData += ' ' + this.attributes;
		SVGData += '></svg>';

		return SVGData;
	}

	private addElement(el: string) {
		this.hasNewElements = true;
		this.SVGElements.push(el);
	}

	private constructSVG() {
		if (this.hasNewElements) {
			// Enhance SVG string with new elements
			this.SVGData = this.SVGData.replace('</svg>', '');
			this.SVGData += this.SVGElements.join('');
			this.SVGData += '</svg>';

			// Generate SVG string from new elements
			this.SVGDataNew = this.createEmptySVG();
			this.SVGDataNew = this.SVGDataNew.replace('</svg>', '');
			this.SVGDataNew += this.SVGElements.join('');
			this.SVGDataNew += '</svg>';

			// Remove elements
			this.SVGElements = [];
			this.hasNewElements = false;
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/lib/SVGImage.ts